import { map } from "rxjs/operators";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { LocationSurchargeMapper } from "./location-surcharge.mapper";
import { LocationMapper } from "../location.mapper";
import { Location } from "../location.model";
import { environment } from "environments/environment";
import { LocationSurcharge } from "./location-surcharge.type";
import { HttpClient, HttpParams } from "@angular/common/http";
import { PaginationList } from "../../shared/grid/pagination-list.model";
import { PaginatedResponse } from "../../shared/http/paginated-response.model";

@Injectable()
export class LocationSurchargeRepository {
  private http = inject(HttpClient);

  public listForQuote(quoteId: number): Observable<Location[]> {
    return this.http
      .get<object[]>(`${environment.apiUrl}/quote/${quoteId}/locationSurcharge`)
      .pipe(map((response) => response.map(LocationMapper.map)));
  }

  public listForLocation(
    locationId: number,
    params: HttpParams = new HttpParams(),
  ): Observable<PaginationList<LocationSurcharge>> {
    return this.http
      .get<PaginatedResponse>(
        `${environment.apiUrl}/location/${locationId}/locationSurcharge`,
        { params: params },
      )
      .pipe(
        map(
          (list) =>
            new PaginationList<LocationSurcharge>(
              list.items.map(LocationSurchargeMapper.map),
              list.total,
            ),
        ),
      );
  }

  public add(
    location: Location,
    surcharge: LocationSurcharge,
    quoteId?: number,
  ): Observable<LocationSurcharge> {
    let payload = {
      carrier: surcharge.getCarrier() ? surcharge.getCarrier().getId() : null,
      name: surcharge.getName(),
      type: surcharge.getType(),
      assignment: surcharge.getAssignment(),
      quote: quoteId || null,
      currency: surcharge.currency,
    };

    payload = this.extendPayloadByContainerLoad(payload, surcharge);

    return this.http
      .post(
        `${
          environment.apiUrl
        }/location/${location.getId()}/surcharge/${surcharge.getDiscriminator()}`,
        payload,
      )
      .pipe(map((json) => LocationSurchargeMapper.map(json)));
  }

  public save(surcharge: LocationSurcharge): Observable<LocationSurcharge> {
    let payload = {
      carrier: surcharge.getCarrier() ? surcharge.getCarrier().getId() : null,
      name: surcharge.getName(),
      type: surcharge.getType(),
      currency: surcharge.currency,
    };

    payload = this.extendPayloadByContainerLoad(payload, surcharge);

    return this.http
      .patch(
        `${environment.apiUrl}/locationSurcharge/${surcharge.getId()}`,
        payload,
      )
      .pipe(map((json) => LocationSurchargeMapper.map(json)));
  }

  public delete(surcharge: LocationSurcharge): Observable<object> {
    return this.http.delete(
      `${environment.apiUrl}/locationSurcharge/${surcharge.getId()}`,
    );
  }

  private extendPayloadByContainerLoad(
    payload: any,
    surcharge: LocationSurcharge,
  ) {
    return {
      ...payload,
      ...surcharge.getRequestParams(),
    };
  }
}
